import comp from "./SinglePointRubricTable";
export default comp;
